import React, { useEffect } from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";

const Footer = () => {
  useEffect(() => {

    const script = document.createElement("script");
    script.src = "https://embed.tawk.to/65f92a59a0c6737bd12256f1/1hpakqsf7";
    script.async = true;
    script.charset = "UTF-8";
    script.setAttribute("crossorigin", "*");
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <footer
      className="text-center text-lg-start text-muted"
      style={{ backgroundColor: "#333", color: "#fff" }}
    >
      <section
        className="d-flex justify-content-center justify-content-lg-between p-4 border-bottom"
        style={{ borderColor: "#fff" }}
      >
        <div className="me-5 d-none d-lg-block"></div>
        <div>
          <a
            href="https://www.bing.com/ck/a?!&&p=aaeeadd32211aa9b2e94a3a6c1fe2bdda68f7f48dd2c8d91ab2b45793c3e8116JmltdHM9MTczNjEyMTYwMA&ptn=3&ver=2&hsh=4&fclid=0238f2d1-43bd-6209-2754-e320421b63aa&psq=piquota+digital+face+book&u=a1aHR0cHM6Ly93d3cuZmFjZWJvb2suY29tL1BpcXVvdGEv&ntb=1"
            className="me-4 text-reset"
            style={{ color: "#fff" }}
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-facebook-f" style={{ fontSize: "25px" }}></i>
          </a>
          <a
            href="https://twitter.com/piquotadigital"
            className="me-4 text-reset"
            style={{ color: "#fff" }}
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-twitter" style={{ fontSize: "25px" }}></i>
          </a>
          <a
            href="https://www.instagram.com/piquotadigital/"
            className="me-4 text-reset"
            style={{ color: "#fff" }}
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-instagram" style={{ fontSize: "25px" }}></i>
          </a>
          <a
            href="https://in.linkedin.com/company/piquota-digital-solutions"
            className="me-4 text-reset"
            style={{ color: "#fff" }}
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-linkedin" style={{ fontSize: "25px" }}></i>
          </a>
        </div>
      </section>

      <section>
        <div className="container text-center text-md-start mt-5">
          <div className="row mt-3">
            <div className="col-md-3 col-lg-4 col-xl-3 mx-auto mb-4">
              {/* Wrap the image with Link to navigate to the homepage */}
              <Link to="https://piquota.ai" className="d-block">
                <img
                  src="logo.png"
                  alt="Logo"
                  style={{
                    maxWidth: "150px",
                    marginBottom: "20px",
                    filter: "invert(100%) saturate(0%) brightness(200%)",
                  }}
                />
              </Link>
              <p style={{ color: "#fff" }}>
                Piquota delivers innovative IT solutions, helping businesses
                streamline processes, enhance user experiences, and achieve
                growth.
              </p>
            </div>

            <div className="col-md-3 col-lg-3 col-xl-3 mx-auto mb-4">
              <h6
                className=" fw-bold mb-4"
                style={{ color: "#fff", fontSize: "24px" }}
              >
                Services
                <span className="rectangle"></span>
              </h6>
              <ul style={{ listStyle: "none", padding: 0, marginTop: "40px" }}>
                <li style={{ marginBottom: "8px" }}>
                  <Link
                    to="/webdevelopment"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    Web Development
                  </Link>
                </li>
                <li style={{ marginBottom: "8px" }}>
                  <Link
                    to="/mobileapplication"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    Mobile App Development
                  </Link>
                </li>
                <li style={{ marginBottom: "8px" }}>
                  <Link
                    to="/nodejs"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    Node.js Development
                  </Link>
                </li>
                <li style={{ marginBottom: "8px" }}>
                  <Link
                    to="/ecommerce"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    E-commerce Development
                  </Link>
                </li>
                <li style={{ marginBottom: "8px" }}>
                  <Link
                    to="/java"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    Java Development
                  </Link>
                </li>
                <li style={{ marginBottom: "8px" }}>
                  <Link
                    to="/enterpriseappdevelopment"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    Enterprise App Development
                  </Link>
                </li>
              </ul>
            </div>

            <div className="col-md-3 col-lg-3 col-xl-3 mx-auto mb-4">
              <ul style={{ listStyle: "none", padding: 0, marginTop: "70px" }}>
                <li style={{ marginBottom: "8px" }}>
                  <Link
                    to="/reactjs"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    React.js Development
                  </Link>
                </li>
                <li style={{ marginBottom: "8px" }}>
                  <Link
                    to="/alservices"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    AI/ML Services
                  </Link>
                </li>
                <li style={{ marginBottom: "8px" }}>
                  <Link
                    to="/digitalmarketing"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    Digital Marketing
                  </Link>
                </li>
                <li style={{ marginBottom: "8px" }}>
                  <Link
                    to="/itconsulting"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    IT Consulting
                  </Link>
                </li>
                <li style={{ marginBottom: "8px" }}>
                  <Link
                    to="/cloudservicesmanagement"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    Cloud Services Management
                  </Link>
                </li>
                <li style={{ marginBottom: "8px" }}>
                  <Link
                    to="/solutiosdesign"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    Solution Design
                  </Link>
                </li>
              </ul>
            </div>

            <div className="col-md-3 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4">
              <h6
                className=" fw-bold mb-4"
                style={{ color: "#fff", fontSize: "24px" }}
              >
                Contact
                <span className="rectangle"></span>
              </h6>
              <p style={{ color: "#fff" }}>
                <i
                  className="fas fa-home me-3"
                  style={{ fontSize: "12px", marginTop: "20px" }}
                ></i>
                13, Aarudhra Enclave, Athipalayam Road, Saravanampatti, Coimbatore
                641035
              </p>
              <p style={{ color: "#fff" }}>
                <i
                  className="fas fa-envelope me-3"
                  style={{ fontSize: "12px" }}
                ></i>{" "}
                contact@piquota.com
              </p>
              <p style={{ color: "#fff" }}>
                <i className="fas fa-phone me-3" style={{ fontSize: "12px" }}></i>{" "}
                +91-98406 57547
              </p>
            </div>
          </div>
        </div>
      </section>

      <div
        className="text-center p-4"
        style={{ backgroundColor: "rgba(0, 0, 0, 0.2)", color: "#fff" }}
      >
        © 2025 Piquota Digital Solutions
      </div>
    </footer>
  );
};

export default Footer;
